document.addEventListener("DOMContentLoaded", () => {
  const colorButtons = document.querySelectorAll(".color-options__container button[data-color]");
  const optionButtons = document.querySelectorAll("[data-product-option]");
  const legendValue = document.querySelector(".color-options__container [data-selected-option-text]");
  const variantInput = document.querySelector("input.product-variant-id");
  const productDataEl = document.querySelector("[data-product-json]");
  const productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;

  if (!productData) {
    console.warn("⚠️ No product JSON found. Exiting.");
    return;
  }

  const formatMoney = (cents) => {
    if (typeof cents !== "number") return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(cents / 100);
  };

  const updatePrice = (variant) => {
    const priceEl = document.querySelector("[data-product-price]");
    const comparePriceEl = document.querySelector("[data-product-compare-price]");

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.classList.remove("hidden");
      } else {
        comparePriceEl.textContent = "";
        comparePriceEl.classList.add("hidden");
      }
    }
  };

  const updateByVariantId = (variantId, updateUrl = true) => {
    const variant = productData.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return console.warn("⚠️ Variant not found:", variantId);

    let imageSrc = null;
    let imageAlt = null;

    if (variant.featured_image?.src) {
      imageSrc = variant.featured_image.src;
      imageAlt = variant.featured_image.alt || variant.title;
    } else if (variant.featured_media?.src) {
      imageSrc = variant.featured_media.src;
      imageAlt = variant.featured_media.alt || variant.title;
    }

    const featuredImg = document.querySelector("[data-featured-media-container] img");
    const featuredAnchor = document.querySelector("[data-featured-media-container] a[data-fslightbox='pdp-gallery']");

    if (featuredImg && imageSrc) {
      featuredImg.src = imageSrc;
      featuredImg.alt = imageAlt;
    }

    if (featuredAnchor && imageSrc) {
      featuredAnchor.href = imageSrc;
    }

  if (variantInput) {
  variantInput.value = variant.id;
  variantInput.dispatchEvent(new Event("change", { bubbles: true }));
}

    const skuEl = document.querySelector("[data-product-sku]");
    if (skuEl) skuEl.textContent = variant.sku || "—";

    updatePrice(variant);

    if (updateUrl) {
      // SUB-110: built from pathname + variant alone, this dropped every other query
      // param on a variant click - including the ?view=fabric guard that selects the
      // Fabric PDP template, so a reload or a shared link fell back to the standard
      // product page. Start from the current URL and set variant on it instead.
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", nextUrl.toString());
    }

    document.querySelectorAll("[data-thumbs-container] .thumb__container").forEach(t => {
      t.classList.remove("active");
    });

    if (imageSrc) {
      const matchingThumb = Array.from(document.querySelectorAll("[data-thumbs-container] img"))
        .find(img => img.src.includes(imageSrc.split("?")[0]));

      if (matchingThumb) {
        matchingThumb.closest(".thumb__container")?.classList.add("active");
      }
    }

    document.dispatchEvent(
      new CustomEvent("variantSelected", {
        detail: {
          variantId: variant.id,
          variant,
          image: imageSrc
        }
      })
    );
  };

  const urlParams = new URLSearchParams(window.location.search);
  const initialVariantId = parseInt(urlParams.get("variant"), 10);
  if (initialVariantId) {
    updateByVariantId(initialVariantId, false);
  }

  optionButtons.forEach(button => {
    button.addEventListener("click", () => {
      const variantId = button.dataset.variantId;
      const optionValue = button.dataset.productOptionValue || "";

      if (!variantId) {
        console.warn("⚠️ No variant ID found for option:", button);
        return;
      }

      const optionGroup = button.closest("[data-product-option-label]");
      if (optionGroup) {
        optionGroup.querySelectorAll("[data-product-option]").forEach(b => b.classList.remove("active"));
      }
      button.classList.add("active");

      if (button.hasAttribute("data-color") && legendValue) {
        legendValue.textContent = optionValue;
      }

      updateByVariantId(variantId);
    });
  });
});